<template>
	<div class="modal" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="vsofModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">{{ title }}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<table v-if="user" class="table table-sm" aria-describedby="attached-institution-user-information-summary">
						<tbody>
							<tr>
								<td>Name:</td>
								<td>{{ user.fullname }}</td>
							</tr>
							<tr>
								<td>Email:</td>
								<td>{{ user.email }}</td>
							</tr>
							<tr>
								<td>Phone:</td>
								<td>{{ user.phone | placeholder }}</td>
							</tr>
							<tr>
								<td>Date of birth:</td>
								<td>{{ user.birth_date | toDate('Do MMMM YYYY') | placeholder }}</td>
							</tr>
							<tr>
								<td>Nationality:</td>
								<td>{{ user.nationality | placeholder }}</td>
							</tr>
							<tr>
								<td>Residency:</td>
								<td>{{ user.residency_status | placeholder }}</td>
							</tr>
							<tr>
								<td>Job Title:</td>
								<td>{{ user.position | placeholder }}</td>
							</tr>
							<tr>
								<td>Identification Document Type:</td>
								<td>{{ user.identification_document_type | placeholder }}</td>
							</tr>
							<tr>
								<td>Identification Document Number</td>
								<td>{{ user.identification_document_number | placeholder }}</td>
							</tr>
							<tr>
								<td>Identification Document Country</td>
								<td>{{ user.identification_document_country | placeholder }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		modalId: {
			type: String,
			required: false,
			default: 'view-attached-institution-user',
		},
		title: {
			type: String,
			required: true,
		},
		user: {
			type: Object,
			required: false,
		},
	},
};
</script>
